// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const EXPLORATORY_DATA_ANALYSIS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.EXPLORATORY_DATA_ANALYSIS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Continuous summary table': {
        systemName: 'Continuous summary table',
        displayName: 'Continuous summary table',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Categorical summary table': {
        systemName: 'Categorical summary table',
        displayName: 'Categorical summary table',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Input table': {
        systemName: 'Input table',
        displayName: 'Input table',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Correlation coefficient table': {
        systemName: 'Correlation coefficient table',
        displayName: 'Correlation coefficient table',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Distribution histograms': {
        systemName: 'Distribution histograms',
        displayName: 'Distribution histograms',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      },
      'Correlation charts between X': {
        systemName: 'Correlation charts between X',
        displayName: 'Correlation charts between X',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      },
      'Correlation charts between X and Y': {
        systemName: 'Correlation charts between X and Y',
        displayName: 'Correlation charts between X and Y',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      },
      'Additional charts': {
        systemName: 'Additional charts',
        displayName: 'Additional charts',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      }
    },
    config: {
      labelColumn: {
        kind: 'columnReference',
        required: true,
        inputDataName: 'Input dataset',
        allowMissingColumn: false,
        validationOptions: {
          allowedLeafTypes: [
            LeafType.INTEGER,
            LeafType.DECIMAL
          ]
        }
      },
      featureColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          allowMissingColumn: false,
          validationOptions: null
        }
      },
      excludedColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          allowMissingColumn: false,
          validationOptions: null
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
